const SWIPE_TRESHOLD = 10000;

export default SWIPE_TRESHOLD;
